(function (app) {
    app.directive("figAutofocus", [function () {
        return {
            link: function (scope, elem) {
                elem.focus();
            }
        };
    }]);
})(window.app); // jshint ignore:line